import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=fb601d9a&"
import script from "./NavBarItem.vue?vue&type=script&lang=ts&"
export * from "./NavBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports